// extracted by mini-css-extract-plugin
module.exports = {"navLinks":"NavLinks_navLinks__3QaE8","aLink":"NavLinks_aLink__1TIuo","selected":"NavLinks_selected__DLIR4"};